var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summon-tutorial"},[_c('h5',{staticClass:"text-shadowed my-3"},[_vm._v("Summon (Gacha)")]),_c('img',{staticClass:"mb-3 poster",attrs:{"src":"/images/articles/gachaPoster.png"}}),_c('SummonTips')],1)}
var staticRenderFns = []

export { render, staticRenderFns }